(function () {
  'use strict';

  angular.module('tfc.retailer.StandardReports')
      .factory('ProductHierarchyFilter', ProductHierarchyFilterClass);

  function ProductHierarchyFilterClass(BaseFilterType, FiltersHelper) {

    function ProductHierarchyFilter(filterData, stateParams, defaultValue) {
      if (!(this instanceof ProductHierarchyFilter)) return new ProductHierarchyFilter(filterData, stateParams, defaultValue);
      this.defaultValue = defaultValue;

      BaseFilterType.call(this, filterData, stateParams);
    }

    ProductHierarchyFilter.prototype = _.create(BaseFilterType.prototype, {
      formatFilterValues: FiltersHelper.formatTreeFilter,
      selectedParams: function (stateParams) {
        return getSelectedParams(stateParams, this.defaultValue);
      },
      isFilterSelected: function (stateParams) {
        return _.map(stateParams, function (hierarchy) {
          return FiltersHelper.equalsDefaultFn(hierarchy);
        });
      }
    });

    function getSelectedParams(stateParams, defaultValue) {
      var hierarchyParams = ['department', 'category', 'classification'];
      var defaultHierarchy = _(hierarchyParams)
          .mapKeys()
          .mapValues(function () { return defaultValue; })
          .value();
      var selectedHierarchy = _(stateParams)
          .pick(hierarchyParams)
          .defaults(defaultHierarchy)
          .value();
      return [selectedHierarchy.department, selectedHierarchy.category, selectedHierarchy.classification];
    }

    return ProductHierarchyFilter;

  }

})();